import React, { useState } from 'react';

import { Divider, Header } from '@rbilabs/universal-components';
import * as Updates from 'expo-updates';

import useEffectOnce from 'hooks/use-effect-once';
import { appVersion, binaryRuntimeAppVersionWithBuildNumber } from 'utils/app-version-info';
import { getDeviceId } from 'utils/device-id';
import { getCurrentCommitHash } from 'utils/environment';

import { EnvItem } from '../components';

export function PublicDiagnostics() {
  const [deviceId, setDeviceId] = useState<string>('');

  useEffectOnce(() => {
    getDeviceId().then(deviceIdResult => setDeviceId(deviceIdResult || ''));
  });

  return (
    <>
      <Divider />
      <Header pt={4} variant="headerFour">
        Device Information
      </Header>
      <EnvItem envKey="Device Id" value={deviceId?.toLowerCase()} />

      <Divider />

      <Header pt={4} variant="headerFour">
        Update OTA Build Info
      </Header>
      <EnvItem envKey="OTA App Version" value={appVersion} />
      <EnvItem envKey="Commit Hash" value={getCurrentCommitHash()} />
      <EnvItem envKey="Build Date" value={Updates.createdAt?.toLocaleString()} />
      <EnvItem envKey="Update Id" value={Updates.updateId} />
      <EnvItem envKey="Update Channel" value={Updates.channel} />
      <EnvItem envKey="Is Embedded Launch?" value={Updates.isEmbeddedLaunch + ''} />

      <Header pt={4} variant="headerFour">
        Binary runtime info
      </Header>
      <EnvItem
        envKey="Binary app runtime version with build number"
        value={binaryRuntimeAppVersionWithBuildNumber}
      />
    </>
  );
}
